var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
import { TransportError } from './framework/Transport';
export class VivitekProjector3and4Series {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`V99G0302`, /^P(\d+)$|^F$/i, tags);
                return match[1] ? match[1] === '1' : this.state.displayBlank.value;
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`V99S0302${blank ? '1' : '0'}`, /^(P|F)/i, tags);
                return match[1].toUpperCase() === 'P' ? blank : this.state.displayBlank.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.displayFreeze = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`V99G0304`, /^P(\d+)$|^F$/i, tags);
                return match[1] ? match[1] === '1' : this.state.displayFreeze.value;
            }),
            set: (freeze, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`V99S0304${freeze ? '1' : '0'}`, /^(P|F)/i, tags);
                return match[1].toUpperCase() === 'P' ? freeze : this.state.displayFreeze.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.firmwareVersion.value;
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`V99G0008`, /P?(.{3,})|^F/i, //FW version is 3 or more characters
                    ['get.firmwareVersion']);
                    if (match[1] !== undefined) {
                        this.state.firmwareVersion.update(match[1]);
                        return true;
                    }
                    return false;
                }
                catch (error) {
                    if (error instanceof TransportError && error.code === 'sendTimeout')
                        return false;
                    throw error;
                }
            }),
            powerOffRestrictions: ['get', 'hasControl'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`V99G0007`, /P(\d+)|F|illegal format/i, tags);
                return match[1] ? match[1] === '2' : this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`${power ? 'V99S0001' : 'V99S0002'}`, /^(P|F)|Illegal format/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 20000 : 120000);
                let newPower = this.state.power.value;
                if (match[1] !== undefined) {
                    newPower = match[1].toUpperCase() === 'P';
                    this.framework.suspend(newPower ? 20000 : 120000);
                }
                return newPower;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`V99G0220`, /^P(\d+)|^F/i, tags);
                return match[1] ? match[1] : this.state.videoInput.value;
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`V99S02${code.padStart(2, '0')}`, /^(P|F)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                return match[1].toUpperCase() === 'P' ? code : this.state.videoInput.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 2000,
                controls: ['power', 'videoInput', 'displayBlank', 'displayFreeze'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socket.port !== 4999)
                return 'connected';
            const initializerSteps = [
                {
                    errorCode: 'verifyFailed',
                    send: `V99G0007`,
                    next: /^P\d+|^F|Illegal/i,
                },
            ];
            return yield CommandSocketInitializer.initialize(this.socket, initializerSteps, credentials);
        });
    }
}
// static properties
VivitekProjector3and4Series.driverType = 'socketDriver';
VivitekProjector3and4Series.key = '-LiPkvMQzkAHqC1lEcYK';
VivitekProjector3and4Series.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r'],
    },
    sendTerminator: '\r',
};
VivitekProjector3and4Series.socketOptions = (config) => {
    return [
        Object.assign(Object.assign({}, VivitekProjector3and4Series.baseSocketOptions), { idleTimeoutMs: 30000, port: 4999 }),
        Object.assign(Object.assign({}, VivitekProjector3and4Series.baseSocketOptions), { idleTimeoutMs: 0, port: 23 }),
    ];
};
